import * as EnvConstants from './envConstants';

type StripVitePrefix<Key extends string> = Key extends `VITE_${infer Rest}`
  ? Rest
  : never;

type EnvKey = StripVitePrefix<keyof typeof EnvConstants>;

export const getEnvVariable = (key: EnvKey): string => {
  return EnvConstants[`VITE_${key}` as keyof typeof EnvConstants] ?? '';
};
